import { Badge } from 'reactstrap';
import { formatKickoff } from '../utils/dates.js';
import { useTheme } from '../theme/useTheme.js';

function TeamButton({ team, selected, disabled, isWinner, onSelect }) {
  const { isDark } = useTheme();
  const logo = (isDark ? team.logoDarkUrl : team.logoLightUrl) ?? team.logoLightUrl;

  const classes = [
    'team-button',
    selected ? 'team-button--selected' : '',
    isWinner ? 'team-button--winner' : '',
  ].join(' ');

  return (
    <button type="button" className={classes} disabled={disabled} onClick={onSelect}
      aria-pressed={selected} aria-label={team.displayName}>
      {logo && <img src={logo} alt="" className="team-button__logo" />}
      <span className="team-button__name">{team.abbreviation || team.displayName}</span>
    </button>
  );
}

export function GameCard({ game, selectedTeamId, locked, onSelect }) {
  const decided = game.isFinal && game.winnerTeamId != null;
  const correct = decided && selectedTeamId != null ? selectedTeamId === game.winnerTeamId : null;

  return (
    <div className={`game-card ${locked ? 'game-card--locked' : ''}`}>
      <div className="game-card__header">
        <span className="text-muted small">{formatKickoff(game.kickoffUtc)}</span>
        <span className="d-flex gap-1 align-items-center">
          {game.isTiebreakerGame && <Badge color="info" className="text-dark" pill>Tiebreaker</Badge>}
          {locked && <Badge color="secondary" pill>Locked</Badge>}
          {game.isFinal && <Badge color="dark" pill>Final</Badge>}
          {correct === true && <Badge color="success" pill>Correct</Badge>}
          {correct === false && <Badge color="danger" pill>Miss</Badge>}
        </span>
      </div>

      <div className="game-card__teams">
        <TeamButton team={game.away} selected={selectedTeamId === game.away.id} disabled={locked}
          isWinner={decided && game.winnerTeamId === game.away.id}
          onSelect={() => onSelect(game.id, game.away.id)} />
        <span className="game-card__at">@</span>
        <TeamButton team={game.home} selected={selectedTeamId === game.home.id} disabled={locked}
          isWinner={decided && game.winnerTeamId === game.home.id}
          onSelect={() => onSelect(game.id, game.home.id)} />
      </div>

      {game.homeScore != null && game.awayScore != null && (
        <div className="game-card__score text-muted small">
          {game.away.abbreviation} {game.awayScore} &ndash; {game.homeScore} {game.home.abbreviation}
        </div>
      )}
    </div>
  );
}
